import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "row", "filterInput", "emptyMessage"]
  static values = { 
    filterable: Boolean,
  }

  connect() {      
    // Initialize filter if enabled
    if (this.filterableValue && this.hasFilterInputTarget) {
      this.filterInputTarget.addEventListener('input', this._debounce(() => {
        this._filterTable()
      }, 300))
    }
  }
  
  _filterTable() {
    if (!this.hasFilterInputTarget) return
    
    const filterText = this.filterInputTarget.value.toLowerCase()
    let visibleCount = 0
    
    this.rowTargets.forEach(row => {
      const text = row.textContent.toLowerCase()
      const matches = text.includes(filterText)
      row.classList.toggle('hidden', !matches)
      if (matches) visibleCount++
    })
    
    // Show or hide empty message
    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.classList.toggle('hidden', visibleCount > 0)
    }
  }
  
  // Utility function to debounce input events
  _debounce(func, wait) {
    let timeout
    return function() {
      const context = this
      const args = arguments
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
  }
}
